import React from 'react'
import Wrapper from '../layout/Wrapper'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import MainCta from '../botones/main-cta'
import ReactSVG from 'react-svg'

const OuterContainer = styled.div`
  background: ${props => (props.fondoRojo ? props.theme.colors.rojoBac : '#fff')};
`

const Contenedor = styled(Wrapper)`
  padding-top: 20px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  text-align: center;

  ${breakpoint('tablet')`
    text-align: left;
    flex-direction: row;
    align-items: center;
  `}

  ${breakpoint('desktop')`
    padding-top: 40px;
    margin-bottom: 60px;
  `}
`

const ContenedorTexto = styled.div`
  order: 2;

  ${breakpoint('tablet')`
    width: 50%;
    order: 1;
  `}
`

const ContenedorImagen = styled.div`
  order: 1;
  margin-bottom: 20px;

  ${breakpoint('tablet')`
    order: 2;
    width: 50%;
    margin-bottom: 0;
  `}

  svg {
    max-width: 100%;
  }
`

const Tarjetas = styled.div`
  font-size: 30px;
  margin-bottom: 20px;
  color: ${props => (props.fondoRojo ? '#fff' : '#000')};
  font-weight: 400;

  ${breakpoint('tablet')`
    font-size: 40px;
  `}

  strong {
    color: ${props => (props.fondoRojo ? '#fff' : props.theme.colors.rojoBac)};
  }
`

const Subtitular = styled.div`
  font-size: 16px;
  color: ${props => (props.fondoRojo ? '#fff' : props.theme.colors.grisOscuro)};
  margin-bottom: 20px;

  ${breakpoint('tablet')`
    font-size: 18px;
  `}
`

const Hero = ({ cta, formUrl, heroImage, titulo, heroSubtitular }) => {
  const fondoRojo = heroImage.includes('rojo')

  return (
    <OuterContainer fondoRojo={fondoRojo}>
      <Contenedor>
        <ContenedorTexto>
          <Tarjetas fondoRojo={fondoRojo}>
            Solicitala <strong>por WhatsApp</strong>
          </Tarjetas>
          <Subtitular fondoRojo={fondoRojo}>{heroSubtitular}</Subtitular>
          <MainCta
            to={formUrl}
            inverse={fondoRojo}
            className="multicanalidad-link-whatsapp"
          >
            {cta}
          </MainCta>
        </ContenedorTexto>
        <ContenedorImagen>
          <ReactSVG path={`/images/iconos/${heroImage}`} alt={titulo} />
        </ContenedorImagen>
      </Contenedor>
    </OuterContainer>
  )
}

export default Hero
